export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const UPDATE_SHIPPING_DETAILS = "UPDATE_SHIPPING_DETAILS";

export const addToCart = (id) => {
  return {
    type: ADD_TO_CART,
    id,
  };
};

export const removeFromCart = (id) => {
  return {
    type: REMOVE_FROM_CART,
    id,
  };
};

export const updateShippingDetails = (shippingDetails) => {
  console.log(" The shipping details are: ", shippingDetails);
  return {
    type: UPDATE_SHIPPING_DETAILS,
    shippingDetails,
  };
};
